var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMediumSm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.582,
    height: 21
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 1347",
    d: "M14.966 21h-4.388L6.738 7.6V17h1.881v4H0v-4h1.567c.078 0 .235-.078.313-.078V4.231c-.078-.157-.157-.235-.313-.235H0v-4h10.813l2.821 9.873L16.377 0h11.205v4h-2.116a1.655 1.655 0 00-.784.313v12.456a4.222 4.222 0 00.784.235H27.5v3.918H16.847V17h1.881V7.44zm-3.526-1.175h2.66l4.466-16.142h1.41V18.1H18.1v1.646h8.306V18.1h-.94c-.235 0-1.959-.235-1.959-1.254V4.153c0-.94 1.567-1.41 1.959-1.41h.862V1.1h-9.09L14.1 12.459h-.94L9.951 1.1H1.175v1.646h.549A1.584 1.584 0 013.056 4v13c0 .705-.784 1.175-1.489 1.175h-.392v1.646h6.269v-1.642H5.563V3.761H6.9z",
    fill: "#555"
  })));
}

export default __webpack_public_path__ + "static/media/medium_sm.2b5cba3c39d04cbe0626953673a1565c.svg";
export { SvgMediumSm as ReactComponent };